import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface DisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function DisclaimerModal({ isOpen, onClose }: DisclaimerModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full h-[90vh] p-0 gap-0 flex flex-col">
        <DialogHeader className="px-6 py-4 border-b bg-card flex-shrink-0">
          <DialogTitle className="text-lg font-semibold">Disclaimer</DialogTitle>
        </DialogHeader>
        
        <div className="relative flex-1 bg-background min-h-0">
          <div className="p-6 overflow-y-auto h-full">
            <div className="prose prose-gray dark:prose-invert max-w-none">
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                Tutti i contenuti presenti su Gildy.it hanno esclusivamente finalità informative e divulgative. 
                La piattaforma è pensata per fornire strumenti e informazioni utili a comprendere meglio il valore di 
                mercato dei metalli preziosi e facilitare un processo decisionale più consapevole.
              </p>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                Gildy non fornisce consulenza finanziaria, patrimoniale, legale o fiscale. Le informazioni pubblicate, 
                comprese le quotazioni, le simulazioni di valore, le valutazioni e le eventuali previsioni generate 
                tramite sistemi di intelligenza artificiale, sono fornite unicamente a scopo informativo e non 
                costituiscono in alcun modo un invito, una sollecitazione o un consiglio a vendere, acquistare o 
                detenere metalli preziosi, gioielli o altri beni.
              </p>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                Le quotazioni e i valori visualizzati possono variare in base alle condizioni di mercato, alla 
                verifica fisica del bene, al peso effettivo, allo stato di conservazione e alle politiche 
                commerciali dell'operatore selezionato.
              </p>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                Il servizio "Blocca Prezzo" costituisce una manifestazione di interesse tra utente e operatore 
                e non garantisce l'effettiva conclusione della transazione.
              </p>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                Il Gildy Trust Score (GTS) e gli eventuali badge associati hanno esclusivamente finalità 
                informativa e descrittiva e non costituiscono certificazione ufficiale, garanzia di affidabilità 
                o attestazione di qualità.
              </p>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                Gildy non istiga in alcun modo alla vendita dei propri beni. Ogni decisione relativa alla 
                vendita deve essere presa in piena autonomia e, se necessario, con il supporto di un 
                professionista qualificato.
              </p>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
                Gildy non acquista, vende né commercia metalli preziosi o gioielli. Il servizio offerto agli 
                operatori del settore è esclusivamente una vetrina digitale per migliorarne la visibilità 
                online e facilitare il contatto con gli utenti.
              </p>

              <p className="text-gray-700 dark:text-gray-300 leading-relaxed font-medium">
                Gildy non interviene in alcun modo nelle transazioni economiche tra utenti e operatori e non 
                si assume alcuna responsabilità per l'utilizzo delle informazioni fornite sul sito né per 
                eventuali trattative o accordi intercorsi tra le parti.
              </p>
            </div>
          </div>
        </div>
        
        <div className="px-6 py-3 border-t bg-muted/30 flex-shrink-0">
          <div className="flex items-center justify-end">
            <Button
              variant="outline"
              size="sm"
              onClick={onClose}
              className="gap-2"
            >
              <X className="h-4 w-4" />
              Chiudi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
